module.exports = __webpack_public_path__ + "img/virtual-tours-min.b494910d.jpg";